(function (w) {
	'use strict';

	function MxDropZone($timeout, vm) {
		var processingQueue = [];
		const MAX_FILESIZE_BASE64_DATA_URL = 5000000;

		var formatUrl = function (url) {
			return vm.formatUrl({ url: url });
		};
		var uploadFile = async function (file) {
			await vm.uploadFile({ file: file });
		};
		return {
			init: init,
			createThumbnail: createThumbnail,
			processSelectedFiles: processSelectedFiles,
		};

		function init(container) {
			addEventHandler(container, 'dragover', cancel);
			addEventHandler(container, 'dragenter', cancel);
			addEventHandler(container, 'drop', dropEvent);
		}

		function processFile(file) {
			processingQueue.push(file);
			$timeout(function () {
				processQueue();
			}, 0);
		}

		function processQueue() {
			while (processingQueue.length > 0) {
				var file = processingQueue.shift();

				$timeout(_processFile.bindToEventHandler(file), 0);
			}
		}

		function _processFile(e, _file) {
			createThumbnail(_file);
			uploadFileDropZone(_file);
		}

		function processSelectedFiles(files) {
			loadFiles(files);
		}

		function dropEvent(e) {
			vm.isInitMode = false;
			vm.scope.$apply();
			e = e || w.event;
			if (e.preventDefault) {
				e.preventDefault();
			}

			if (!vm.readOnly) {
				var dt = e.dataTransfer;
				var files = dt.files;
				loadFiles(files, true);
			}

			return false;
		}

		function loadFiles(files, isDropEvent) {
			if (files === null) {
				return;
			}

			vm.maxSizeExceedFiles = [];
			let _maxSizeExceedFiles = [];

			vm.maxCountExceedFiles = [];
			let _maxCountExceedFiles = [];

			vm.wrongTypeFiles = [];
			let _wrongTypeFiles = [];

			let filesAdded = 0;

			for (var i = 0; i < files.length; i++) {
				var file = files[i];

				if (!vm.ignoreFileLimitations && vm.storageInfo.maxFilesPerObject >= 0 && vm.files.length + filesAdded + 1 > vm.storageInfo.maxFilesPerObject) {
					_maxCountExceedFiles.push(file);
					continue;
				}

				if (!isFileTypeAllowed(file)) {
					_wrongTypeFiles.push(file);
					continue;
				}

				if (vm.storageInfo.maxFileSize > 0 && vm.storageInfo.maxFileSize < file.size) {
					_maxSizeExceedFiles.push(file);
					continue;
				}

				loadFile(file);
				filesAdded++;
			}
			if (vm.storageInfo.maxFilesPerObject >= 0 && vm.files.length + filesAdded >= vm.storageInfo.maxFilesPerObject) {
				_maxCountExceedFiles = _maxCountExceedFiles.concat(_wrongTypeFiles).concat(_maxSizeExceedFiles);
				_wrongTypeFiles = [];
				_maxSizeExceedFiles = [];
			}

			if (_maxCountExceedFiles.length > 0 || _wrongTypeFiles.length > 0 || _maxSizeExceedFiles.length > 0) {
				vm.maxCountExceedFiles = _maxCountExceedFiles;
				vm.wrongTypeFiles = _wrongTypeFiles;
				vm.maxSizeExceedFiles = _maxSizeExceedFiles;
				if (isDropEvent) {
					vm.scope.$apply();
				}
			}
		}

		function loadFile(file) {
			let fileList = vm.files;

			file.isNew = true;
			file.selected = true;
			makeAsDataUrl(file).then(
				$timeout(function () {
					fileList.push(file);
					processFile(file);
				})
			);
		}

		function makeAsDataUrl(file) {
			w.URL = w.URL || w.webkitURL;
			return new Promise((resolve, reject) => {
				if (file.size < MAX_FILESIZE_BASE64_DATA_URL) {
					var reader = new FileReader();
					reader.onloadend = function (e, reader, file) {
						if (reader.error === null) {
							file.url =
								'data:' +
								file.type +
								';base64,' +
								btoa(
									[].reduce.call(
										new Uint8Array(this.result),
										function (p, c) {
											return p + String.fromCharCode(c);
										},
										''
									)
								);
							resolve(file);
						} else {
							reject(reader.error);
						}
					}.bindToEventHandler(reader, file);

					reader.readAsArrayBuffer(file);
				} else if (w.URL.createObjectURL) {
					file.url = w.URL.createObjectURL(file);
					resolve(file);
				}
				vm.scope.$apply();
			});
		}

		function createThumbnail(file) {
			if (!file.type.match(/image.*/)) {
				return;
			}

			var img = document.createElement('img');
			img.crossOrigin = 'anonymous';
			img.onload = function (e, _file) {
				var DEFAULT_SIZE = 160;

				var canvas = document.createElement('canvas');
				var ctx = canvas.getContext('2d');

				var originalWidth = img.width;
				var originalHeight = img.height;
				var canvasSize = Math.min(parseInt(vm.width) || DEFAULT_SIZE, originalWidth);
				canvas.width = canvasSize;
				canvas.height = canvasSize;
				var thumbSize = { width: canvasSize, height: canvasSize };

				var ratioX = canvasSize / originalWidth;
				var ratioY = canvasSize / originalHeight;
				var ratio = Math.min(ratioX, ratioY);

				thumbSize.width = originalWidth * ratio;
				thumbSize.height = originalHeight * ratio;

				thumbSize.offsetX = (canvasSize - thumbSize.width) / 2;
				thumbSize.offsetY = (canvasSize - thumbSize.height) / 2;

				ctx.drawImage(img, thumbSize.offsetX, thumbSize.offsetY, thumbSize.width, thumbSize.height);
				_file.thumbnail = canvas.toDataURL('image/png');
				_file.status = 2;
				vm.scope.$apply();
			}.bindToEventHandler(file);

			if (file.isVirtual) {
				img.src = file.url;
			} else {
				img.src = file.isNew ? file.url : formatUrl(file.url);
			}
		}

		async function uploadFileDropZone(file) {
			try {
				await uploadFile(file);
				vm.scope.$applyAsync();
			} catch (error) {
				throw new Error(error.message);
			}
		}

		function cancel(e) {
			e = e || w.event;
			(e.originalEvent || e).dataTransfer.dropEffect = 'copy';
			if (e.preventDefault) {
				e.preventDefault();
			}

			return false;
		}

		function addEventHandler(obj, evt, handler) {
			if (obj.addEventListener) {
				// W3C method
				obj.addEventListener(evt, handler, false);
			} else {
				// Old school method.
				obj['on' + evt] = handler;
			}
		}

		function isFileTypeAllowed(file) {
			if (vm.ignoreFileLimitations || !vm.storageInfo.fileExtensions) {
				return true;
			}
			let extensions = vm.storageInfo.fileExtensions.split(',');
			let fileExtension = '.' + file.name.split('.').pop();
			let fileType = file.type.split('/')[0];

			return extensions.some((extension) => extension === fileExtension || extension === fileType);
		}
	}

	Function.prototype.bindToEventHandler = function bindToEventHandler() {
		var handler = this;
		var boundParameters = Array.prototype.slice.call(arguments);
		//create closure
		return function (e) {
			e = e || window.event; // get window.event if e argument missing (in IE)
			var params = boundParameters.slice();
			params.unshift(e);
			handler.apply(this, params);
		};
	};
	w.mx = w.mx || {};
	w.mx.components = w.mx.components || {};
	w.mx.components.DropZone = MxDropZone;
})(window);
